import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import DateTimeModal from "./DateTimeModal";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../utils/UtilsFormule";
import UtilsUrl from "../utils/UtilsUrl";
import FileService from "../services/FileService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import uploadAndDownloadService from "../services/uploadAndDownloadFile";
import SellingService from "../services/SellingService";

const DataTableTransactionSell = ({ state, refFacture, listProduits, bonSortir, change, setChange }) => {
  const navigate = useNavigate();
  const [showElement, setShowElement] = useState([]);
  const [creationDate, setCreationDate] = useState(null);
  const [reference, setReference] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [row, setRow] = useState([]);



  const handleDateChange = (newDate) => {
    setCreationDate(newDate);
    console.log("Updated creation date:", newDate);
  };

  const handleReferenceChange = (newReference) => {
    setReference(newReference);
    console.log("Updated reference:", newReference);
  };
  console.log("listProduits", listProduits);
  const [products, setProducts] = useState(listProduits);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [pathFile, setPathFile] = useState(null);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const { SearchBar } = Search;
  // const MyExportCSV = (props) => {
  //   const handleClick = () => {
  //     props.onExport();
  //   };
  //   return (
  //     <div>
  //       <button className="btn btn-dark" onClick={handleClick}>
  //         <i class="fas fa-download"></i> Télécharger CSV
  //       </button>
  //     </div>
  //   );
  // };
  // Effect to handle modal visibility after creationDate is updated
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, [])
  function nameFormatter(cell, row) {
    return (
      <span>
        {row.userCreator.firstName} {row.userCreator.lastName}
      </span>
    );
  }
  function warehouseFormatter(cell, row) {
    if (cell === "Garbage WARHOUSE") {
      return <span>Dépôt des retours (Système)</span>;
    } else {
      return <span>{cell}</span>;
    }
  }
  function dateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(cell)}</span>;
  }
  function stateDocument() {
    if (state === 2) {
      return <span style={{ cursor: "pointer" }} className="badge bg-success float-right">Terminé</span>;
    } else if (state === 1) {
      return <span style={{ cursor: "pointer" }} className="badge bg-primary float-right">En cours</span>;
    }
  }
  function buttonDeleteFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-danger btn-sm"
        onClick={() => console.log(row)}
      >
        <i class="fas fa-trash"></i>
      </button>
    );
  }
  const handleClick = async (row) => {
    // Check if the reference or creationDate has changed
    const isReferenceChanged = row.uniqueId !== reference;
    const isCreationDateChanged = row?.creationDate !== creationDate;

    if (isReferenceChanged || isCreationDateChanged) {
      // If either value has changed, update the state and show the modal
      console.log(row.uniqueId);

      // Update state values
      await setReference(row.uniqueId);
      await setCreationDate(row?.creationDate);

      // Show the modal
      setRow(row)
      setModalVisible(true);
    }
  };
  function buttonModifierFormatter(cell, row) {
    return (
      <>

        <button
          style={{ width: 40 }}
          class="btn bg-black btn-sm "
          onClick={() => handleClick(row)}
        >
          <i class="fas fa-edit"></i>
        </button>

      </>

    );
  }
  const columns = [
    {
      dataField: "warehouseName",
      text: "Dépôt",
      headerAlign: "center",
      formatter: warehouseFormatter,
    },
    {
      dataField: "creationDate",
      text: "Date livraison",
      align: "center",
      formatter: dateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "name",
      text: "Responsable",
      align: "center",
      formatter: nameFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "name",
      text: "BL",
      align: "center",
      formatter: nameFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "name",
      text: "BR",
      headerAlign: "center",
      align: "center",

      formatter: buttonFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    bonSortir && {
      dataField: "isDeleted",
      text: "Modifier",
      formatter: buttonModifierFormatter,

      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    bonSortir && {
      dataField: "isDeleted",
      text: "Action",
      formatter: buttonDeleteFormatter,

      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];
  const onShowFileInOtherWindowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const onUploadFileHandler = (refOperation) => {
    console.log("refop", refOperation)
    FileService.generateBonReceptionSell(
      getCurrentUserId(),
      refFacture,
      refOperation
    ).then((response) => {
      if (response.data["success"]) {
        setPathFile(response.data["success"]);
        onShowFileInOtherWindowHandler(
          UtilsUrl.fileRetailURL() + response.data["success"]
        );
      }
    });
  };


  const onUploadFileBLFactureHandler = (refOperation) => {
    console.log("refop", refOperation)
    FileService.generateBLFactureSell(
      getCurrentUserId(),
      refFacture,
      refOperation
    ).then((response) => {
      if (response.data["success"]) {
        setPathFile(response.data["success"]);
        onShowFileInOtherWindowHandler(
          UtilsUrl.fileRetailURL() + response.data["success"]
        );
      }
    });
  };



  function buttonFormatter(cell, row) {
    if (row.path !== null) {
      return (
        <span>
          <button
            // style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            onClick={() =>
              onShowFileInOtherWindowHandler(
                UtilsUrl.fileRetailURL() + row.path
              )
            }
          >
            <i class="fas fa-eye"></i>
          </button>
        </span>
      );
    } else {
      return (
        <span>
          <button
            // style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            onClick={() => onUploadFileHandler(row.uniqueId)}
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    }
  }

  const rates = (row) => {
    if (
      row.productSalesHistories !== null &&
      row.productSalesHistories.length !== 0
    ) {
      console.log("productSalesHistories", row.productSalesHistories);
      return (
        <div class="col-md-12">
          <div class="card card-dark collapsed-card">
            <div class="card-header">
              <h3 class="card-title">Les opérations</h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="card-body">{listRates(row.productSalesHistories)}</div>
          </div>
        </div>
      );
    }
  };
  const listRates = (list) => {
    return (
      <table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th>Libellé</th>

            <th style={{ width: "15%" }}>Opération</th>
            <th style={{ width: "15%" }}>Note</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>Responsable</th>
            <th style={{ width: "8%" }}>Q.R</th>
            <th style={{ width: "8%" }}>Q.T</th>
          </tr>
        </thead>
        <tbody>
          {list &&
            list.map((element, i) => (
              <tr key={i}>
                <td>{element.productSale.product.name}</td>

                <td className="text-center">{typeFormatter(element.type)} </td>
                <td>{element.note}</td>

                <td>{UtilsFormule.formatDateHours(element.creationDate)} </td>
                <td>
                  <span>
                    {element.creator.firstName} {element.creator.lastName}
                  </span>
                </td>

                <td className="text-center">{element.quantity} </td>

                <td className="text-center">{element.productSale.quantity}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  function typeFormatter(type) {
    if (type === 1) {
      return <span style={{ cursor: "pointer" }} className="badge bg-success">Nouveau sortie</span>;
    } else if (type === 2) {
      return <span style={{ cursor: "pointer" }} className="badge bg-warning">Refusé</span>;
    } else if (type === 3) {
      return <span style={{ cursor: "pointer" }} className="badge bg-primary">Sortie du retours</span>;
    }
  }



  function buttonFileFormatter(element, refFacture) {
    if (element.path !== null) {
      return (
        <span>
          <a
            className="btn btn-success btn-sm"
            onClick={() =>
              onShowFileInOtherWindowHandler(
                UtilsUrl.fileRetailURL() + element.path
              )
            }
          >
            Bon de livraison de : {element.uniqueId}
          </a>
          <p></p>
        </span>
      );
    } else {
      return (
        <span>
          <a
            className="btn btn-warning btn-sm"
            onClick={() => onUploadFileHandler(element.uniqueId, refFacture)}
          >
            Bon de livraison de : {element.uniqueId}
          </a>
          <p></p>
        </span>
      );
    }
  }

  function buttonBLFactureFileFormatter(element, refFacture) {

    return (
      <span>
        <a
          className="btn btn-warning btn-sm"
          onClick={() => onUploadFileBLFactureHandler(element.uniqueId, refFacture)}
        >
          BL/Facture de : {element.uniqueId}
        </a>
        <p></p>
      </span>
    );

  }
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const generateFactureFromBonSortie = (refOperation, idWarehouse) => {
    console.log("refOperation", refOperation)
    console.log("idWarehouse", idWarehouse)
    SellingService.createFactureFromOperation(
      getCurrentUserId(),
      refOperation, idWarehouse
    ).then((response) => {
      if (response.data.success) {
        setOpenSuccessAlert(true);
        setSuccessAlertText("Enregistrement avec succées");
        setTimeout(() => {
          navigate(`/allFactureSell`);
        }, 2000);

      }
    });
  };

  const generateFactureAvoirFromBonRetour = (refOperation, idWarehouse) => {
    console.log("refOperation", refOperation)
    console.log("idWarehouse", idWarehouse)
    SellingService.createFactureAvrFromOperation(
      getCurrentUserId(),
      refOperation, idWarehouse
    ).then((response) => {
      if (response.data.success) {
        setOpenSuccessAlert(true);
        setSuccessAlertText("Enregistrement avec succées");
        setTimeout(() => {
          navigate(`/allFactureSell`);
        }, 2000);

      }
    });
  };
  function buttonFactureFormatter(element) {
    if (!showElement.includes("WAREHOUSE_MANAGER")) {
      if (element?.typeTransaction === 2 && element?.idFacture === null) {
        return (
          <span>
            <a
              className="btn btn-danger btn-sm float-right"
              onClick={() =>
                generateFactureAvoirFromBonRetour(
                  element.uniqueId, element.idWarehouse
                )
              }
            >
              Facture Avoir l'opération : {element.uniqueId}
            </a>
            <p></p>
          </span>
        );
      } else if (element?.typeTransaction !== 2 && element?.idFacture === null) {
        return (
          <span>
            <a
              className="btn btn-info btn-sm float-right"
              onClick={() =>
                generateFactureFromBonSortie(
                  element.uniqueId, element.idWarehouse
                )
              }
            >
              Facturer l'opération : {element.uniqueId}
            </a>
            <p></p>
          </span>
        );
      }
    }



  }

  const importProduct = (row) => {
    return (
      <div>
        {console.log("row", row)}
        <div className="row">
          <div class="col-md-4">

            {buttonFileFormatter(row, refFacture)}

          </div>
          <div class="col-md-4">

            {buttonBLFactureFileFormatter(row, refFacture)}

          </div>
          <div class="col-md-4">

            {buttonFactureFormatter(row)}

          </div></div>
        <div className="row">
          <div class="col-md-12">
            {rates(row)}
          </div>
        </div>
      </div>

    );
  };
  const expandRow = {
    renderer: (row) => importProduct(row),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b>-</b>;
      }
      return <b>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b>-</b>;
      }
      return <b>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les livraisons</h3>
        {stateDocument()}
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="uniqueId"
          data={products}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>

              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      <DateTimeModal
        creationDate={creationDate}
        reference={reference}
        handleDateChange={handleDateChange}
        handleReferenceChange={handleReferenceChange}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        row={row}
        change={change}
        setChange={setChange}
      />
    </div>
  );
};
export default DataTableTransactionSell;
